module.exports = __webpack_public_path__ + "static/img/code.8d6af6c2.png";